import BookForm from "../Components/BookForm";
import { useBooksStore } from "../state/BooksStore";

export default function AddBook() {
  const addBook = useBooksStore((s) => s.addBook);

  function handleAdd(data) {
    addBook(data);
    alert("Book added!");
    // navigate("/"); if using router
  }

  return (
    <main
      style={{
        maxWidth: 600,
        margin: "24px auto",
        padding: "0 16px",
        fontFamily: "system-ui, sans-serif",
      }}
    >
      <h1
        style={{
          marginTop: 0,
          fontSize: 28,
          fontWeight: 600,
          color: "#0f172a",
        }}
      >
        Add a Book
      </h1>

      <BookForm onSubmit={handleAdd} />
    </main>
  );
}
